/**
 * Extract YouTube video id from common watch / embed / share / Shorts URLs.
 *
 * Flag-neutral: directory cards parse intro videos while
 * `pga-com-coach-profile-ux` is off. Do not gate this helper on
 * FLAG_COACH_PROFILE_UX.
 */
export function extractYouTubeVideoId(url) {
  if (!url || typeof url !== 'string') return null
  const trimmed = url.trim()
  const shorts = trimmed.match(/\/shorts\/([^/?&#]+)/i)
  if (shorts) return shorts[1]
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  const matches = trimmed.match(regExp)
  return matches && matches[7] ? matches[7] : null
}
